export const POST_CELL_SETTINGS_REQUEST = 'POST_CELL_SETTINGS_REQUEST' as const;
export const POST_CELL_SETTINGS_SUCCESS = 'POST_CELL_SETTINGS_SUCCESS' as const;
export const POST_CELL_SETTINGS_ERROR = 'POST_CELL_SETTINGS_ERROR' as const;

export const GET_SETTINGS_REQUEST = 'GET_SETTINGS_REQUEST' as const;
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS' as const;
export const GET_SETTINGS_ERROR = 'GET_SETTINGS_ERROR' as const;

export const POST_SETTINGS_REQUEST = 'POST_SETTINGS_REQUEST' as const;
export const POST_SETTINGS_SUCCESS = 'POST_SETTINGS_SUCCESS' as const;
export const POST_SETTINGS_ERROR = 'POST_SETTINGS_ERROR' as const;
